{
  "Envanter": "Voorraad",
  "envanter": {
    "Alış Firma": "Leverancier",
    "Alış Tarih": "Aankoopdatum",
    "Alış Tarihi": "Aankoopdatum",
    "Değer": "Waarde",
    "Envanter": "Voorraad",
    "Envanter Detay": "Voorraad detail",
    "Hareket": "Actie",
    "Hareket Notu": "Actienotitie",
    "Marka": "Merk",
    "Model": "Model",
    "Nitelik": "Kenmerk",
    "Serial": "Serienummer",
    "Çoklu Giriş": "Meerdere Invoer",
    "ExcelAktar": "Exporteren naar Excel",
    "Status": "Status",
    "Kod": "Code",
    "Ad": "Naam",
    "Tip": "Type",
    "Tür": "Soort",
    "Zimmet": "Bewaring",
    "Durum": "Toestand",
    "Açıklama": "Beschrijving",
    "Aktif Kayıt": "Actief Record",
    "Pasif Kayıt": "Passief Record",
    "Sıra": "Rang",
    "Aktif/Pasif": "Actief/Passief",
    "Şube": "Vestiging",
    "Bilgi Notu": "Info-notitie"
  }
}
